@if (block?.contents?.length) {
  <section class="discover-content" [style.color]="block.textColor">
    <div class="content block-container" [class.has-background]="block.mediaBackground || block.backgroundColor">
      @if (block.title) {
        <h1 [innerHtml]="block.title | safeHtml"></h1>
      }
      @if (block.sliderEnabled) {
        <lib-swiper [slides]="block.contents" [options]="swiperOptions">
          <ng-template swiperContent let-slide="item">
            <ng-container *ngTemplateOutlet="slideTmp; context: { slide: slide }"></ng-container>
          </ng-template>
        </lib-swiper>
        @if (!swiperComponent?.swiper?.isBeginning || !swiperComponent?.swiper?.isEnd) {
          <div class="d-none d-lg-flex carousel-buttons-wrapper">
            <button color="primary" mat-fab class="carousel-button left" [style.color]="block.textColor" [style.border-color]="block.textColor" [class.disabled]="swiperComponent?.swiper?.isBeginning" (click)="swiperComponent?.swiper?.slidePrev()">
              <mat-icon>navigate_before</mat-icon>
            </button>
            <button color="primary" mat-fab class="carousel-button right" [style.color]="block.textColor" [style.border-color]="block.textColor" [class.disabled]="swiperComponent?.swiper?.isEnd" (click)="swiperComponent?.swiper?.slideNext()">
              <mat-icon>navigate_next</mat-icon>
            </button>
          </div>
        }
      } @else {
        <div class="discover-content__list-view" [class.justify-content-center]="block.contents?.length < 4">
          @for (slide of block.contents; track slide) {
            <div class="col-12 col-sm-6 col-md-4 col-xl-3 slide py-3">
              <ng-container *ngTemplateOutlet="slideTmp; context: { slide: slide }"></ng-container>
            </div>
          }
        </div>
      }
    </div>
  </section>
}


<ng-template let-slide="slide" #slideTmp>
  <div (click)="navigate($event, slide)" class="card-item" [class.inactive]="!slide.active">
    <div class="image">
      @if (slide.mediaImage) {
        <img
          [cropImage]="slide.mediaImage | preSignedUrl | async"
          [crop]="slide?.mediaImage?.crop"
          imageWidth="400"
          [attr.alt]="slide.mediaImage?.alt" >
      } @else {
        <div class="image-placeholder" [placeholderImage]="slide.bundle"></div>
      }
      @if (slide.payable && paymentEnabled) {
        <app-card-label
          class="price-wrapper"
          [show]="true"
          [cssClass]="slide.isPaid && 'paid-label'"
          [label]="(slide.isPaid ? 'PURCHASED -' : '') +  (slide.price | currency:(slide.currency | uppercase):'symbol')">
        </app-card-label>
      }

    </div>
    <div class="description">
      <h2 [innerHtml]="slide.title | safeHtml" class="mb-0"></h2>
    </div>
  </div>
</ng-template>
